export const FETCH_DELETE_TEMPLATE_REQUEST = 'FETCH_DELETE_TEMPLATE_REQUEST'
export const FETCH_DELETE_TEMPLATE_SUCCESS = 'FETCH_DELETE_TEMPLATE_SUCCESS'
export const FETCH_DELETE_TEMPLATE_FALUIRE = 'FETCH_DELETE_TEMPLATE_FALUIRE'
